import React from "react";

/**
 * Inline brand wordmarks for technology partners.
 * White / silver text on dark navy with each brand's signature color accent.
 * Designed for the partners marquee — recognizable, lightweight, reliable.
 */

const baseTextClass =
  "font-display font-extrabold tracking-[0.04em] leading-none text-[#F5F5F5] text-[26px] sm:text-[30px] md:text-[34px] select-none";

export const Fortinet = () => (
  <span className={baseTextClass} title="Fortinet" aria-label="Fortinet">
    <span style={{ color: "#EE3124" }}>F</span>ortinet
  </span>
);

export const Kaspersky = () => (
  <span className={baseTextClass} title="Kaspersky" aria-label="Kaspersky">
    <span style={{ color: "#00A88E" }}>K</span>aspersky
  </span>
);

export const Microsoft = () => (
  <span
    className="inline-flex items-center gap-3 select-none"
    title="Microsoft"
    aria-label="Microsoft"
  >
    {/* Four-colour mark */}
    <svg width="24" height="24" viewBox="0 0 24 24" className="shrink-0">
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="13" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="13" width="10" height="10" fill="#00A4EF" />
      <rect x="13" y="13" width="10" height="10" fill="#FFB900" />
    </svg>
    <span
      className="font-display font-medium tracking-[0.01em] text-[#F5F5F5] text-[26px] sm:text-[30px] md:text-[34px] leading-none"
      style={{ fontFamily: "Montserrat, sans-serif" }}
    >
      Microsoft
    </span>
  </span>
);

export const Quest = () => (
  <span
    className="inline-flex items-baseline gap-1 select-none"
    title="Quest Software"
    aria-label="Quest Software"
  >
    <span className={baseTextClass}>
      <span style={{ color: "#FFC72C" }}>Q</span>uest
    </span>
  </span>
);

export const Wazuh = () => (
  <span
    className="font-display font-bold tracking-[0.02em] text-[#F5F5F5] text-[26px] sm:text-[30px] md:text-[34px] lowercase select-none"
    title="Wazuh"
    aria-label="Wazuh"
  >
    <span style={{ color: "#3F76C2" }}>w</span>azuh
  </span>
);

export const Ubika = () => (
  <span
    className={`${baseTextClass} uppercase`}
    title="UBIKA"
    aria-label="UBIKA"
  >
    UB<span style={{ color: "#00B7C3" }}>I</span>KA
  </span>
);

export const Wallix = () => (
  <span
    className={`${baseTextClass} uppercase`}
    title="WALLIX"
    aria-label="WALLIX"
  >
    WA<span style={{ color: "#0070D2" }}>L</span>LIX
  </span>
);

export const Netscout = () => (
  <span
    className={`${baseTextClass} uppercase`}
    title="NETSCOUT"
    aria-label="NETSCOUT"
  >
    NETS<span style={{ color: "#E4002B" }}>C</span>OUT
  </span>
);

export const PARTNER_MARKS = [
  { name: "Fortinet", Component: Fortinet },
  { name: "Kaspersky", Component: Kaspersky },
  { name: "Microsoft", Component: Microsoft },
  { name: "Quest", Component: Quest },
  { name: "Wazuh", Component: Wazuh },
  { name: "Ubika", Component: Ubika },
  { name: "Wallix", Component: Wallix },
  { name: "Netscout", Component: Netscout },
];
